
import { defineComponent } from 'vue'
import { getDispatch, DispatchDto } from '@/api/dispatch'
import global from '@/utils/global'

export default defineComponent({
    name: 'DispatchTable',
    data () {
        return {
            tableData: [] as DispatchDto[],
            showAll: false,
            sortParams: {
                sort: 'claim_ratio',
                order: 'desc'
            }
        }
    },
    computed: {
        displayData (): DispatchDto[] {
            const data = this.tableData as DispatchDto[]
            if (this.showAll || data.length <= 5) {
                return data
            }
            return data.slice(0, 5)
        }
    },
    async created () {
        await this.fetchTableData()
    },
    methods: {
        async fetchTableData () {
            try {
                const result = await getDispatch({
                    page: 1,
                    pageSize: 100, // 获取所有数据，不分页
                    sort: this.sortParams.sort,
                    order: this.sortParams.order
                })
                this.tableData = result.data
            } catch (error) {
                console.error('获取被派遣单位列表失败:', error)
            }
        },
        exportTable () {
            window.location.href =
                process.env.VUE_APP_BASE_URL +
                '/company/export?token=' + global.token
            this.$message.success('导出成功')
        },
        toggleViewMore () {
            this.showAll = !this.showAll
        },
        handleSortChange ({ prop, order }: { prop: string; order: string | null }) {
            if (prop === 'claim_ratio') {
                if (order === 'ascending') {
                    this.sortParams.sort = 'claim_ratio'
                    this.sortParams.order = 'asc'
                } else if (order === 'descending') {
                    this.sortParams.sort = 'claim_ratio'
                    this.sortParams.order = 'desc'
                } else {
                    this.sortParams.sort = 'claim_ratio'
                    this.sortParams.order = 'desc'
                }
                this.fetchTableData()
            }
        }
    }
})
